import React from 'react';
import PropTypes from 'prop-types';

import { factory } from '../positions/asset-position-details/asset-position-details-container';
import AssetPositionDetails from '../positions/asset-position-details/asset-position-details';

function MMInstrumentsAssetPositionDetails(props) {
  return (<AssetPositionDetails
    {...props}
    renderBottomSeparator={true}
    row={Object.assign({}, props.row, {
      accruedInterestUnit: props.referenceCurrency,
      maturityInterestUnit: props.referenceCurrency,
      maturityInterestPandIUnit: props.referenceCurrency,
    })}
    positionType={props.row.positionType}
  />);
}

MMInstrumentsAssetPositionDetails.propTypes = {
  referenceCurrency: PropTypes.string,
  row: PropTypes.object,
};

export default factory({
  component: MMInstrumentsAssetPositionDetails,
  rowFragmentOmit: ['priceHistory'],
  rowFragmentExtend: {
    amount: true,
    accruedInterest: true,
    maturityDate: true,
    maturityInterest: true,
    maturityInterestPandI: true,
    maturityInterestPandIPosCcy: true,
    maturityInterestPosCcy: true,
    positionType: true,
  },
  mapperExtend: ({ currency }) => ({
    amountUnit: currency,
    maturityInterestPandIPosCcyUnit: currency,
    maturityInterestPosCcyUnit: currency,
  }),
});
